import Y2012 from './2012';

const Server = [
    ...Y2012
];

export default Server;